import {AxiosError} from 'axios';
import {useMutation, useQueryClient} from 'react-query';
import {toast} from 'react-toastify';
import {
  IPostAccountNumberPayload,
  PostAccountNumber,
} from './postAccountNumbers';

const usePostAccountNumber = (
  handleAfterSuccess?: (variables: IPostAccountNumberPayload) => void,
) => {
  const queryClient = useQueryClient();

  const {isLoading, mutate, mutateAsync, isSuccess} = useMutation({
    mutationFn: (payload: IPostAccountNumberPayload) =>
      PostAccountNumber(payload),

    onSuccess: (_, variables) => {
      handleAfterSuccess?.(variables);
      queryClient.invalidateQueries(['get-user-account_numbers']);
    },

    onError: (error: AxiosError<IAxiosErr>) => {
      toast.error(
        error?.response?.data?.message ||
          'مشکلی پیش آمده ،لطفا در زمان دیگری مراجعه فرمایید',
      );
    },
  });

  return {isLoading, mutate, mutateAsync, isSuccess};
};

export default usePostAccountNumber;
